import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import debounce from "lodash.debounce";
import api from "utils/api";
import APIConstant from "utils/constant";
import cogoToast from "cogo-toast";
import SimpleBackdrop from "utils/general";
import { CommonConfig } from "CommonConfig";
import moment from "moment";
import ReactToPrint from "react-to-print";
import Barcode from "react-barcode";

const PerformaInvoice = (props) => {
  const [userId, setUserId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);
  const [invoiceId, setInvoiceId] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(
    CommonConfig.dataTableConfig.rowsPerPage
  );
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CommonConfig.dataTableConfig.rowsPerPageOptions
  );
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [invoicePrintId, setInvoicePrintId] = useState(0);
  const [productList, setProductList] = useState([]);
  const [variantList, setVariantList] = useState([]);
  const [barcodeData, setBarcodeData] = useState([]);
  const [content, setContent] = useState({
    header: "",
    footer: "",
    image: "",
  });
  const printButtonRef = useRef(null);
  const componentRef = useRef(null);

  useEffect(() => {
    const data = localStorage.getItem("Infodata");
    const token = localStorage.getItem("Token");
    const access = localStorage.getItem("PageAccess");

    if (token) {
      setUserId(data);
      setUserPageAccess(access);
      fetchInvoiceList(data);
      GetProductMaster(data);
      GetVariantMaster(data);
      GetImageConfiguration(data);

      if (props.location?.state && props.location.state.InvoiceId) {
        setInvoicePrintId(props.location.state.InvoiceId);
      }
    } else {
      props.history.push("/login");
    }
  }, []);

  useEffect(() => {
    debouncedSearch(userId, search);
  }, [search]);

  const debouncedSearch = useCallback(
    debounce((userId, keyword) => {
      fetchInvoiceList(userId, {}, keyword);
    }, 400),
    []
  );

  useEffect(() => {
    if (invoiceList.length) {
      if (invoicePrintId) {
        handleOpen("", "Print");
      }
    }
  }, [invoiceList]);

  const fetchInvoiceList = async (userId, event = {}, query = "") => {
    // setLoading(true);
    const params = {
      UserId: userId,
      page: event.first ? event.first / rowsPerPage : 0,
      limit: event.rows || rowsPerPage,
      Query: query || "",
    };

    try {
      const response = await api.post(
        APIConstant.path.GetPerformaInvoice,
        params
      );
      if (response.Success === 1) {
        setInvoiceList(response.Data);
        setTotalRecords(response.TotalRecords);
        setFirst(event.first || 0);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const GetProductMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetProductMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          setProductList(
            response.Data.filter((product) =>
              product.Type?.includes("Finished Product")
            )
          );
        }
      })
      .catch((err) => {});
  };

  const GetImageConfiguration = async (UserId) => {
    try {
      let paramData = {
        UserId: UserId,
      };
      await api
        .post(APIConstant.path.GetImageConfiguration, paramData)
        .then(async (response) => {
          let resp = await response;
          if (resp?.success) {
            const image = `${process.env.REACT_APP_NODE_API_ENDPOINT}/document/${resp?.data[0]?.ImagePath}`;
            setContent({
              header: resp?.data[0]?.Header,
              footer: resp?.data[0]?.Description,
              image: image,
            });
          }
        });
    } catch (error) {
      console.log("load script image", error);
    }
  };

  const GetVariantMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetVariantList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setVariantList(filterArry);
        }
      })
      .catch((err) => {});
  };

  const GetPerformaInvoiceById = async (InvoiceId) => {
    try {
      let params = {
        UserId: userId,
        InvoiceId,
      };
      api
        .post(APIConstant.path.GetPerformaInvoiceById, params)
        .then((response) => {
          if (response.Success === 1) {
            const { InvoiceDate, ItemList } = response.Data;
            let tempItemList = [];
            let productIds = productList.map((item) => item._id);
            ItemList.forEach((item) => {
              let variant = variantList.find((v) => v.value === item.ItemId);
              if (productIds.includes(variant.Product)) {
                tempItemList.push({
                  InvoiceDate: InvoiceDate,
                  MfgDate: item.MfgDate,
                  BatchNo: item.BatchNo,
                  ExpiryDate: item.ExpiryDate,
                  ItemName: item.ItemName,
                  Barcode: item.BarcodeNo,
                  Weight: item.Quantity + item.UnitName,
                  MRP: item.Mrp,
                  Rate: item.RateIncludingGST,
                });
              }
            });
            setBarcodeData(tempItemList);
            if (printButtonRef) {
              printButtonRef.current.click();
            }
          } else {
            // console.log(response.Message);
          }
        })
        .catch((err) => {});
    } catch (e) {
      console.log(e);
    }
  };

  const deleteInvoice = async (e) => {
    try {
      let params = {
        InvoiceId: invoiceId,
        UserId: userId,
      };
      await api
        .post(APIConstant.path.DeletePerformaInvoice, params)
        .then(async (response) => {
          let res = await response;
          if (res?.Success === 1) {
            cogoToast.success(res?.Message);
            setInvoiceId("");
            setShowDeleteModal(false);
            await fetchInvoiceList(userId, 0);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const handleOpen = (data = {}, type = "Add") => {
    if (type === "Add") {
      props.history.push("/admin/add-performa-invoice");
    } else if (type === "View") {
      props.history.push({
        pathname: "/admin/add-performa-invoice",
        state: {
          InvoiceId: data?._id,
          Type: "View",
        },
      });
    } else if (type === "Edit") {
      props.history.push({
        pathname: "/admin/add-performa-invoice",
        state: {
          InvoiceId: data?._id,
          Type: "Edit",
        },
      });
    } else if (type === "Delete") {
      setShowDeleteModal(true);
      setInvoiceId(data._id);
    } else if (type === "Print") {
      if (data) {
        GetPerformaInvoiceById(data._id);
      } else GetPerformaInvoiceById(invoicePrintId);
    }
  };

  const actionTemplate = (rowData) => (
    <div className="icon-only-btn">
      {userPageAccess?.includes("Print Performa Invoice") && (
        <i
          className="pi pi-print"
          onClick={() => handleOpen(rowData, "Print")}
        ></i>
      )}
      {userPageAccess?.includes("Edit Performa Invoice") && (
        <i
          className="icon-editImage"
          onClick={() => handleOpen(rowData, "Edit")}
        ></i>
      )}
      {userPageAccess?.includes("View Performa Invoice") && (
        <i
          className="icon-view"
          onClick={() => handleOpen(rowData, "View")}
        ></i>
      )}
      {userPageAccess?.includes("Delete Performa Invoice") ? (
        <div onClick={(e) => handleOpen(rowData, "Delete")}>
          <i class="icon-delete"></i>{" "}
        </div>
      ) : null}
    </div>
  );

  const onPageChange = (e) => {
    setRowsPerPage(e.rows);
    fetchInvoiceList(userId, e, search);
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-arrow-up-left"></i>
          <h2>Performa Invoice</h2>
        </div>
        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-position-relative">
            <InputText
              type="search"
              onInput={(e) => setSearch(e.target.value)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 30 }}
            />
            {!search ? <i className="icon-search"></i> : null}
          </div>

          {userPageAccess?.includes("Add Performa Invoice") ? (
            <div>
              <div className="e-add-btn" onClick={(e) => handleOpen(e, "Add")}>
                <i className="icon-add"></i>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <hr />
      {loading ? <SimpleBackdrop /> : null}
      <DataTable
        className="main-table table-td e-company-table"
        value={invoiceList}
        paginator
        rows={rowsPerPage}
        totalRecords={totalRecords}
        lazy
        onPage={onPageChange}
        first={first}
        emptyMessage="No records found"
        responsiveLayout="scroll"
        editMode="row"
        dataKey="id"
        rowsPerPageOptions={rowsPerPageOptions}
        globalFilter={search}
        responsive={false}
        resizableColumns={true}
        columnResizeMode="fit"
        scrollable={true}
        scrollWidth="auto"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      >
        <Column header="Sr. No" body={(data, props) => props.rowIndex + 1} />
        <Column
          field="InvoiceDate"
          header="Date"
          body={(rowData) => moment(rowData.InvoiceDate).format("DD/MM/YYYY")}
        />
        <Column field="InvoiceNo" header="Invoice No" />
        <Column
          field="ItemName"
          header="Raw Material/Item"
          body={(rowData) =>
            rowData?.ItemList?.map((item) => item.ItemName).join(", ")
          }
        />
        <Column field="ClientName" header="Client Name" />
        <Column field="GSTIN" header="GSTIN" />
        <Column
          field="TotalAmountExcludingGST"
          header="Total Amt (Excl. GST)"
        />
        <Column
          field="TotalAmountIncludingGST"
          header="Total Amt (Incl. GST)"
        />
        <Column body={actionTemplate} header="Actions" />
      </DataTable>

      <Dialog
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setInvoiceId("");
        }}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Performa Invoice</div>
          <div
            className="dialog-close"
            onClick={() => {
              setShowDeleteModal(false);
              setInvoiceId("");
            }}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <h6>Are you sure want to delete this?</h6>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={() => {
              setShowDeleteModal(false);
              setInvoiceId("");
            }}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => deleteInvoice(e)}
            type="submit"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <ReactToPrint
        trigger={() => (
          <div className="p-d-none">
            <button ref={printButtonRef}>Print</button>
          </div>
        )}
        content={() => componentRef?.current}
        documentTitle="Invoice"
        onAfterPrint={() => {
          setBarcodeData([]);
          setInvoicePrintId("");
        }}
      />

      <div className="p-d-none">
        <div className="im-p-dp" ref={componentRef}>
          {barcodeData.map((item, index) => (
            <div className="p-d-flex p-ai-baseline p-jc-center" key={index}>
              {/* Print the same QR code twice */}
              {[1].map((_, duplicateIndex) => (
                <div key={duplicateIndex}>
                  <div className="im-print-main">
                    <div className="p-d-flex">
                      {content.image ? (
                        <p>
                          <img src={content.image} />
                        </p>
                      ) : null}
                      <p
                        dangerouslySetInnerHTML={{
                          __html: content.header,
                        }}
                      ></p>
                    </div>
                    <div className="im-print">
                      <p className="im-name">
                        {item.ItemName ? item.ItemName : ""}
                      </p>
                      <p className="im-pcs">
                        {item.Weight ? `Net Weight:${item.Weight}` : ""}
                      </p>
                      <p className="im-weight">
                        {item.MfgDate
                          ? `Packed On: ${moment(item.MfgDate).format(
                              "DD/MM/YYYY"
                            )}`
                          : ""}
                      </p>
                      <p className="im-final">
                        {item.ExpiryDate
                          ? `Best Before: ${moment(item.ExpiryDate).format(
                              "DD/MM/YYYY"
                            )}`
                          : ""}
                      </p>

                      <p className="im-qc-check">
                        {item.BatchNo ? `Batch No: ${item.BatchNo}` : ""}
                      </p>
                      {/* <p className="im-final">{item.MRP ? item.MRP : ""}</p> */}

                      <p className="im-final">
                        {item.Rate ? `Price: ${item.Rate}` : ""}
                      </p>

                      <p className="im-qr">
                        {item.Barcode ? <Barcode value={item.Barcode} /> : ""}
                      </p>
                      {/* <p className="im-qr-bottom">
                                    {item.BarcodeName ? item.BarcodeName : ""}
                                  </p> */}
                    </div>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: content.footer,
                      }}
                    ></p>
                  </div>
                </div>
              ))}
              {/* Page break after every set of 2 identical QR codes */}
              <div style={{ pageBreakAfter: "always" }}></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PerformaInvoice;
